import React, { useEffect, useState } from 'react'
import galleryApi from '../../api/gallery';
import { Waypoint } from 'react-waypoint';
import Actions from '../../store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { convertBytesToGb } from '../../utils';

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';



let GalleryPictures = ({ selectFile, picker }) => {
  let gallery = useSelector(data => data.gallery);
  let dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(gallery?.pageLoaded);
  const [totalPages, setTotalPages] = useState(null);
  const [noMoreProducts, setNoMoreProducts] = useState(gallery?.allLoaded || false);


  const getData = (page) => {
    try {
      setLoading(true);
      const limit = 20
      galleryApi.getGallery(page, limit)
        .then(async (res) => {
          if (res?.data?.error == false) {
            if (gallery?.pageLoaded < res?.data?.data?.page) {
              const newRecords = res?.data?.data?.data.filter(newRecord =>
                !gallery.data.some(existingRecord => existingRecord._id === newRecord._id)
              );
              dispatch(Actions.addGalleryList({
                data: [...gallery?.data, ...newRecords],
                pageLoaded: newRecords.length > 0 ? res?.data?.data?.page : gallery?.pageLoaded,
                allLoaded: res?.data?.data?.data?.length < limit,
                kbUsed: res?.data?.data?.kbUsed || gallery?.kbUsed
              }))
            }
            setTotalPages(res?.data?.data?.totalPages);
            setLoading(false);
            if (res?.data?.data?.data?.length < limit) {
              setNoMoreProducts(true);
            }
            setPage(page)
          }
        })
        .catch(error => {
          console.log(error.message);
          setLoading(false);
        });
    } catch (error) {
      console.log(error.message);
      setLoading(false);
    }
  }

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className={`bg-white ${!picker && "p-2"}`}>
            <div className="d-flex justify-content-between align-items-center border-bottom pb-3 mb-3">
              <h4>Gallery</h4>
              {gallery?.data?.length > 0 && (
                <div className="badge bg-dark text-white px-3 py-2">
                  <i className="fas fa-database me-2"></i>
                  {convertBytesToGb(gallery?.kbUsed)} GB Used
                </div>
              )}
            </div>
            <div className="gallery">
              {gallery?.data.map((data, index) => (
                <div className="gallery-item border" key={index}
                  onClick={() => {
                    try {
                      if (picker) {
                        selectFile(data?.imagePth)
                      }
                    } catch (error) {
                      console.log(error.message)
                    }
                  }}>
                  <LazyLoadImage
                    key={index} 
                    src={data?.imagePth}
                    effect="blur"
                    alt={`Gallery ${index}`}
                    width="100%"
                    height="auto"
                  />
                </div>
              ))}
              {loading && (
                <>
                  {[...Array(7)].map((data, index) => {
                    return <LazyLoadImage
                      key={index}
                      src={"/assets/images/animations/picture-loader.gif"}
                      effect="blur"
                      alt={`Gallery loader`}
                      width="100%"
                      height="auto"
                    />
                  })}
                </>
              )}
            </div>
            {noMoreProducts ? <div className="d-flex justify-content-center py-3 align-items-center">
              <small className="text-center">No more found</small>
            </div> : !loading && <Waypoint
              onEnter={() => !loading && (totalPages === null || page < totalPages) && getData(page + 1)}
            />}
          </div>
        </div>
      </div >
    </>
  )
}

export default GalleryPictures